"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSubscriptionCheckoutContextType_SubscriptionManage = void 0;
var UserSubscriptionCheckoutContextType_SubscriptionManage;
(function (UserSubscriptionCheckoutContextType_SubscriptionManage) {
    UserSubscriptionCheckoutContextType_SubscriptionManage["SUBSCRIPTION_MANAGE"] = "subscription_manage";
})(UserSubscriptionCheckoutContextType_SubscriptionManage || (exports.UserSubscriptionCheckoutContextType_SubscriptionManage = UserSubscriptionCheckoutContextType_SubscriptionManage = {}));
